/**
 * @generated SignedSource<<2fe4c607cadbe996f5a81fb4e9161963>>
 * @relayHash eeb341c01a4d12157855648a050b1205
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6837d0415941ad8e042c359d3da1eee1785982c246262d2aab74624649bfce1c

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraListSettingMigrationInput = {
  cloudId: string;
  nodes?: ReadonlyArray<JiraListSettingMigrationData> | null | undefined;
};
export type JiraListSettingMigrationData = {
  columns?: ReadonlyArray<string | null | undefined> | null | undefined;
  groupBy?: string | null | undefined;
  jql?: string | null | undefined;
  projectId: AGG$Long;
};
export type usePaidListNINConfigMigration_migrateCurrentProjectMutation$variables = {
  input: JiraListSettingMigrationInput;
};
export type usePaidListNINConfigMigration_migrateCurrentProjectMutation$data = {
  readonly jira_listSettingMigrationMutation: {
    readonly __typename: "JiraListSettingMigrationPayload";
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type usePaidListNINConfigMigration_migrateCurrentProjectMutation = {
  response: usePaidListNINConfigMigration_migrateCurrentProjectMutation$data;
  variables: usePaidListNINConfigMigration_migrateCurrentProjectMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "message"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "usePaidListNINConfigMigration_migrateCurrentProjectMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraListSettingMigrationPayload",
        "kind": "LinkedField",
        "name": "jira_listSettingMigrationMutation",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePaidListNINConfigMigration_migrateCurrentProjectMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraListSettingMigrationPayload",
        "kind": "LinkedField",
        "name": "jira_listSettingMigrationMutation",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6837d0415941ad8e042c359d3da1eee1785982c246262d2aab74624649bfce1c",
    "metadata": {},
    "name": "usePaidListNINConfigMigration_migrateCurrentProjectMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "b6c757641f8101d620b9b7b04da1bf81";

export default node;
